<template>
    <div>
      <mcheader></mcheader>
      <div class="shop-banner-area shop-list text-center">
        <div class="about-banner-text">
          <div class="banner-title">
            <h2>Products</h2>
          </div>
          <div class="breadcrumbs">
            <ul>
              <li class="home"><a href="index.html">Home</a><span> > </span></li>
              <li>Shop</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- banner end -->
      <!--Start Product Details area  -->
      <section class="product-detail-area">
        <div class="container">
          <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
              <div class="product-img-tab clearfix">
                <div class="product-main-img tab-content">
                  <div id="one" role="tabpanel"  class="p-tab-img " v-for="(item,index) in detailList" :key="index" :class="{active:index==ins}">
                    <a href="#"><img id="zoom_01" :src="item.url" data-zoom-image="img/shop/big1.jpg" alt=""></a>
                  </div>
                </div>
                <div class="product-img-list">
                  <ul role="tablist">
                    <li role="presentation" class="active" v-for="(item,index) in detailList" :key="index" @click="active(index)">
                      <a href="#one" aria-controls="one" role="tab" data-toggle="tab">
                      <img :src="item.url" alt=""></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
              <div class="product-detail">
                <div class="product-title">
                  <h2>Cetria postma </h2><br>
                  <h4>$110.00 <del>130</del></h4>
                </div>
                <h5>Available: <span> In Stock</span> </h5>

                <p class="detail">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incidt utore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris    nisi ut aliquip ex ea commodo consequa uis aute irure dolor in reprehenderit </p>
                <div class="size-quantity clearfix">
                  <div class="single-size-quantity" style="vertical-align: middle;margin-bottom: 0;">
                    <h4 style="margin-bottom: 0">Size:</h4>

                      <el-select name="category" class="category-items" style="width: 80%;height: 40px" v-model="value" @change="getgg" size="10">
                        <el-option  v-for="(item,index) in productNorm" :key="index" :value="index" :label="item.norm1 +'/'+ item.norm2">{{item.norm1}}/{{item.norm2}}</el-option>
                      </el-select>

                  </div>
                  <div class="single-size-quantity" style="vertical-align: middle">
                    <h4>Quantity:</h4>
                      <el-input-number v-model="num" @change="handleChange" :min="1" :max="Quantity" label="描述文字"></el-input-number>
                  </div>
                </div>
                <div class="wish-icon-product-details text-left">
                  <ul>
                    <li><a  style="cursor:pointer;" data-toggle="tooltip" title="shopping cart" @click="getShopcar"><i class="fa fa-shopping-cart" data-toggle="modal" :data-target="biaoqian"  ></i></a></li>
                    <!--<li><a href="#" data-toggle="tooltip" title="buy"><i class="fa fa-credit-card-alt"></i></a></li>-->
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <div class="product-description-tab">
                <div class="description-tab-menu">
                  <ul class="clearfix" role="tablist">
                    <li role="presentation" class="active"><a href="#description" aria-controls="description" role="tab" data-toggle="tab">Description</a></li>
                    <li role="presentation"><a href="#specification" aria-controls="specification" role="tab" data-toggle="tab">information</a></li>
                    <li role="presentation"><a href="#review" aria-controls="review" role="tab" data-toggle="tab">Reviews</a></li>
                  </ul>
                </div>
                <div class="tab-content">
                  <div role="tabpanel" class="tab-pane active" id="description">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla patur. Excepteur sint occaecat cupidatat non proident reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat</p>

                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse</p>
                  </div>
                  <div role="tabpanel" class="tab-pane" id="specification">
                    <p>Veniam quasi voluptatem facere nesciunt laborum, quibusdam amet totam fugit, blanditiis doloribus alias eveniet dolore pariatur dolores aliquid!</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex consectetur minima quod officiis magni, aspernatur. Ea consectetur ab in, consequatur alias, quo sit. Optio vitae cupiditate, consectetur veritatis cumque odio magnam voluptates voluptas eligendi, minima tenetur voluptatum dolor autem, doloribus expedita obcaecati.</p>
                  </div>
                  <div role="tabpanel" class="tab-pane" id="review">
                    <p>Similique animi consequatur pariatur voluptas tempore, dolores obcaecati dolorum quia odit harum. Quos nemo, minima totam quidem ipsum labore.</p>
                    <ul>
                      <li> <i class="fa fa-circle"></i> Minus placeat eligendi neque doloribus sed ratione repellendus a illo similique, sint quisquam perferendis eum nam nihil dolor fugit blanditiis, explicabo, recusandae hic qui exercitationem aspernatur excepturi voluptate unde. </li>
                      <li> <i class="fa fa-circle"></i> Quaerat magnam, perferendis, sapiente doloremque error omnis esse in saepe quos eveniet quasi ex fugit eligendi consectetur nobis amet. </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--End Product Details area  -->
      <!--Related Product Start -->
      <div class="related-prouct-area home-two">
        <div class="container">
          <div class="row">
            <div class="col-xs-12">
              <div class="section-title">
                <h4>Related Product</h4>
              </div>
            </div>
          </div>
          <div class="tab-content row">
            <div class="related-product-wrapper" >
              <div class="col-xs-12 col-width" v-for="(item,index) in Randomlist" :key="index">
                <div class="single-product">
                  <div class="single-product-item">
                    <div class="single-product-img clearfix hover-effect">
                      <a @click="godetail(item)">
                        <img class="primary-image" :src="item.img_url" alt="">
                      </a>
                    </div>
                    <div class="single-product-info clearfix">
                      <div class="pro-rating">
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                        <i class="fa fa-star"></i>
                      </div>
                      <div class="pro-price">
                        <span class="new-price">${{item.product_price}}</span>
                        <!--<span class="old-price">$180</span>-->
                      </div>
                      <h3><a >{{item.product_name}}</a></h3>
                    </div>
                    <div class="wish-icon-hover text-center">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="row">-->
            <!--<div class="col-xs-12">-->
              <!--<div class="section-button text-center">-->
                <!--<a href='#' class='slider-button'>View More <i class="fa fa-angle-right"></i></a>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        </div>
      </div>
      <!--Related Product End -->
      <!-- client start -->
      <mcfoot></mcfoot>

      <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal"
                      aria-hidden="true">×
              </button>
              <h4 class="modal-title" id="myModalLabel">
                提示
              </h4>
            </div>
            <div class="modal-body" style="font-size: 20px">
              {{modal}}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default"
                      data-dismiss="modal">关闭
              </button>
              <button type="button" class="btn btn-primary " data-dismiss="modal"  @click="goshopcar">
                去看购物车
              </button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
      </div><!-- /.modal -->
    </div>
</template>

<script>
import mcheader from '@/components/Mcheader'
import mcfoot from '@/components/Mcfoot'
import https from './js/https.js'
export default {
  name: 'Detail',
  components:
        {
          mcheader,
          mcfoot
        },
  data () {
    return {
      detailList: [], // 产品轮播数组
      ins: 0,
      productId: '',
      Randomlist: [],
      productNorm: [],
      gg_id: 0,
      product_norm_id: '', // 产品规格id
      modal: '添加成功', // 提示框文字
      Quantity: 0, // 选择产品数量
      value: '',
      num: 0,
      biaoqian: '',
      Quantity1: 1 // 选择的数量
    }
  },
  methods: {
    // 获取产品的详情图
    getDetailpicture () {
      console.log(this.$route)
      this.productId = this.$route.query.productId
      console.log(this.productId)
      https.fetchGet('mocalilie/api/images', {
        productId: this.productId
      }).then((res) => {
        console.log(res)
        this.detailList = res.data.data
      })
    },
    // 获取推荐产品
    getRecommendproduct () {
      console.log(this.productId)
      https.fetchGet('mocalilie/api/images/getRandomRecommendedProduct', {
        productId: this.productId
      }).then((res) => {
        console.log(res)
        this.Randomlist = res.data.data
        this.$nextTick(function () { // ==》更新dom后，执行轮播
          $('.tab-item-slider').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 5,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1199, 4],
            itemsDesktopSmall: [980, 3],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1]
          })
          $('.client-owl').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 6,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1399, 6],
            itemsDesktopSmall: [980, 4],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1]
          })
          $('.trend-item-slider').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 3,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1199, 2],
            itemsDesktopSmall: [980, 2],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1]
          })
          // $('.related-product-wrapper').owlCarousel({
          //   autoPlay: false,
          //   slideSpeed: 2000,
          //   pagination: false,
          //   navigation: true,
          //   items: 6,
          //   /* transitionStyle : "fade", */ /* [This code for animation ] */
          //   navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          //   itemsDesktop: [1399, 5],
          //   itemsDesktopSmall: [980, 3],
          //   itemsTablet: [768, 2],
          //   itemsMobile: [479, 1]
          // })
          $('.testimonial-owl-wrap').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 1,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1399, 1],
            itemsDesktopSmall: [980, 1],
            itemsTablet: [768, 1],
            itemsMobile: [479, 1]
          })
          $('.tab-item-slider-two').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 5,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1399, 3],
            itemsDesktopSmall: [980, 3],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1]
          })
          $('.tab-item-slider').owlCarousel({
            autoPlay: false,
            slideSpeed: 2000,
            pagination: false,
            navigation: true,
            items: 5,
            /* transitionStyle : "fade", */ /* [This code for animation ] */
            navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            itemsDesktop: [1199, 4],
            itemsDesktopSmall: [980, 3],
            itemsTablet: [768, 2],
            itemsMobile: [479, 1]
          })
          $('#slider-range').slider({
            range: true,
            min: -80,
            max: 460,
            values: [ 25, 325 ],
            slide: function (event, ui) {
              $('#amount').val('$' + ui.values[ 0 ] + ' - $' + ui.values[ 1 ])
            }
          })
          $('#amount').val('$' + $('#slider-range').slider('values', 0) +
            ' - £' + $('#slider-range').slider('values', 1))
          $('#nivoslider').nivoSlider({
            effect: 'random', // 设置幻灯变化效果
            slices: 15, // 动画效果参数
            boxCols: 8, // box动画效果参数
            boxRows: 4, // 动画效果参数
            animSpeed: 500,
            pauseTime: 5000,
            startSlide: 0,
            directionNav: true,
            controlNavThumbs: true,
            prevText: 'Pr <br /> ev',
            nextText: 'Ne <br /> xt',
            pauseOnHover: false,
            manualAdvance: false
          })
          console.log('aaa')
        })
      })
    },
    godetail (i) {
      console.log(i)
      console.log(i.product_id)
      this.productId = i.product_id
      https.fetchGet('mocalilie/api/images', {
        productId: this.productId
      }).then((res) => {
        console.log(res)
        this.detailList = res.data.data
      })
      https.fetchGet('mocalilie/api/productNorm', {
        productId: this.productId
      }).then((res) => {
        console.log(res)
        this.productNorm = res.data.data
      })
    },
    // 获取产品规格
    getProductNorm () {
      https.fetchGet('mocalilie/api/productNorm', {
        productId: this.productId
      }).then((res) => {
        console.log(res)
        this.productNorm = res.data.data
      })
    },
    // 点击缩略图显示大图
    active (num) {
      this.ins = num
      console.log(num)
    },
    // 添加到购物车
    getShopcar () {
      var userid = sessionStorage.getItem('userId')
      console.log(userid)
      console.log(this.value)
      console.log(this.Quantity1)
      if (userid == null) {
        this.open()
      } else {
        if (this.value !== '' && this.Quantity1 !== 0 && userid !== null) {
          console.log('添加成功')
          this.modal = '添加成功'
          this.biaoqian = '#myModal'
          this.product_norm_id = this.productNorm[this.gg_id].id
          console.log(this.product_norm_id)
          const productid = this.productId
          console.log(productid)
          https.fetchPost('mocalilie/api/shopcar/addShopcar', {
            product_norm_id: this.product_norm_id,
            user_id: userid,
            product_count: this.Quantity1
          }).then((res) => {
            console.log(res)
          })
        } else {
          console.log('请选择规格')
          this.modal = '请选择规格和购买数量'
          this.biaoqian = '#myModal'
        }
      }
    },
    open () {
      this.$confirm('当前未登陆，请登陆你的账户', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false,
        center: true
      }).then(() => {
        this.$router.push('/login')
      })
    },
    getgg (e) {
      console.log(e)
      this.gg_id = e
      this.Quantity = this.productNorm[this.gg_id].stock
      this.product_norm_id = this.productNorm[this.gg_id].id
      console.log(this.gg_id)
      console.log(this.Quantity)
      console.log(this.product_norm_id)
    },
    // 获取选择数量
    handleChange (value) {
      console.log(value)
      this.Quantity1 = value
    },
    goshopcar () {
      this.$router.push('/shopcar')
    }
  },
  created () {
    this.getDetailpicture()
    this.getProductNorm()
  },
  mounted () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
    this.getRecommendproduct()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Detail.vue